import { Injectable } from '@angular/core';
import { AcmicService, FormBase, TextBox } from '@mapfre-design-library/src/public_api';
import { Constants } from '@models/constants';
import { FormBaseInputsService } from '@services/common/form-base-inputs.service';

@Injectable({
  providedIn: 'root',
})
export class AddressInputService {
  constructor(private fbInpService: FormBaseInputsService,
    private acmicService:AcmicService
  ) {}
  public valid = true;
  getInputs(
    classes?: string,
    address?: string,
    apartment?: string,
    label?: string,
    policyId?: string,
    addressType?: string
  ) {
    if (policyId && policyId.length === 10) {
      this.valid = false;
    }
    const inputs: FormBase<any>[] = [
      new TextBox({
        additionalClasses: `${Constants.FORM_CONTROL} ${classes}`,
        inputType: 'address',
        key: 'changeAddress',
        label: 'Address*',
        value: address,
        required: this.valid,
        minLength: 1,
        addressType,
        maxLength: 150,
        type: 'text',
        validationMessageError: 'VALID_ADDRESS',
      }),
      new TextBox({
        additionalClasses: `${Constants.FORM_CONTROL} ${classes}`,
        inputType: 'text',
        key: 'changeAddressAPT',
        label: 'Apt / Suite / Other',
        value: apartment && apartment !== '' ? apartment.trim() : apartment,
        required: false,
        minLength: 1,
        maxLength: 50,
        type: 'text',
        validationMessageError: 'VALID_ADDRESS_APT',
      }),
      new TextBox({
        additionalClasses: `${Constants.FORM_CONTROL} ${classes}`,
        inputType: 'poBoxNumber',
        key: 'changeAddress_poBox',
        label: this.acmicService.isACMIC() ? 'PO Box' : 'PO Box number',
        addressType,
        type: 'text',
      }),
      this.fbInpService.getInputTextBox('zipcode', 'changeAddress_zipCode', 'ZIP code', 'text'),
      this.fbInpService.getInputTextBox('text', 'changeAddress_city_state', 'City, State', 'text'),
      this.fbInpService.getInputSelectBox('select', 'changeAddress_multipleCities', 'City', 'select'),      
      this.fbInpService.getInputTextBox('text', 'changeAddress_state', 'State', 'text'),
      this.fbInpService.getInputTextBox('zipcode', 'changeAddress_PO_zipCode', 'ZIP code', 'text'),
      this.fbInpService.getInputTextBox('text', 'changeAddress_PO_city_state', 'City, State', 'text'),
      this.fbInpService.getInputSelectBox('select', 'changeAddress_PO_multipleCities', 'City', 'select'),
      this.fbInpService.getInputTextBox('text', 'changeAddress_PO_state', 'State', 'text'),
    ];
    return inputs;
  }
}
